export const styleSheet = () => ({
    container: {}
});
